const AWS = require('aws-sdk')

const BUCKET_NAME = 'static.liverunapp.com'
const BUCKET_REGION = 'ap-northeast-1'
const IAM_USER_KEY = 'AKIA3MCQSGCD6KB3XGZG'
const IAM_USER_SECRET = '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'
let cloudfront = new AWS.CloudFront({
  region: BUCKET_REGION,
  accessKeyId: IAM_USER_KEY,
  secretAccessKey: IAM_USER_SECRET,
  Bucket: BUCKET_NAME
})

var cloudfrontParams = {
  DistributionId: 'E23ZABNNI3PH00',
  /* required */
  InvalidationBatch: {
    /* required */
    CallerReference: "'" + Math.floor(Date.now() / 1000) + "'",
    /* required */
    Paths: {
      /* required */
      Quantity: 1,
      /* required */
      Items: [
        '/*',
      ]
    }
  }
}
export default {
  uploadToS3(file, banner, callback) {
    let s3bucket = new AWS.S3({
      region: BUCKET_REGION,
      accessKeyId: IAM_USER_KEY,
      secretAccessKey: IAM_USER_SECRET,
      Bucket: BUCKET_NAME
    })

    s3bucket.createBucket(function (data) {
      var params = {
        Bucket: BUCKET_NAME,
        Key: 'app/top_banner/' + file.name,
        Body: file.data
      }





      s3bucket.upload(params, function (err, data) {
        if (err) {
          callback(err)
        } else {
          var paramss = {
            Bucket: BUCKET_NAME,
            Key: 'app/v1.json',
          }
          s3bucket.getObject(paramss, function (err, existingdata) {
            var json = JSON.parse(existingdata.Body.toString('utf-8'))
            if (banner == 'US') {
              json.view_us.top_banner_image_url = data.Location
            } else {
              json.view.top_banner_image_url = data.Location
            }

            var file = JSON.stringify(json)
            paramss.Body = file
            s3bucket.putObject(paramss, function (err, datass) {
              if (!err) {
                cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
                  if (err) console.log(err, err.stack) // an error occurred
                  else callback(data) // successful response
                })

              }
            })
          })
        }
      })
    })
  },
  updateBannerLink(link,banner, callback) {
    let s3bucket = new AWS.S3({
      region: BUCKET_REGION,
      accessKeyId: IAM_USER_KEY,
      secretAccessKey: IAM_USER_SECRET,
      Bucket: BUCKET_NAME
    })


    var paramss = {
      Bucket: BUCKET_NAME,
      Key: 'app/v1.json',
    }

    s3bucket.getObject(paramss, function (err, existingdata) {
      var json = JSON.parse(existingdata.Body.toString('utf-8'))
      //json.view.top_banner_link_url = link
      if (banner == 'US') {
        json.view_us.top_banner_link_url = link
      } else {
        json.view.top_banner_link_url = link
      }
      var file = JSON.stringify(json)
      paramss.Body = file
      s3bucket.putObject(paramss, function (err, datass) {
        if (!err) {

          cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
            if (err) console.log(err, err.stack) // an error occurred
            else callback(datass) // successful response
          })
        }
      })
    })

  },
  selectNoImage(arg, callback) {
    let s3bucket = new AWS.S3({
      region: BUCKET_REGION,
      accessKeyId: IAM_USER_KEY,
      secretAccessKey: IAM_USER_SECRET,
      Bucket: BUCKET_NAME
    })

    var paramss = {
      Bucket: BUCKET_NAME,
      Key: 'app/v1.json',
    }

    s3bucket.getObject(paramss, function (err, existingdata) {
      var json = JSON.parse(existingdata.Body.toString('utf-8'))
      if (arg == 'US') {
        json.view_us.top_banner_image_url = ''
      } else {
        json.view.top_banner_image_url = ''
      }
      //json.view.top_banner_image_url = ''
      var file = JSON.stringify(json)
      paramss.Body = file
      s3bucket.putObject(paramss, function (err, datass) {
        if (!err) {
          cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
            if (err) console.log(err, err.stack) // an error occurred
            else callback(datass) // successful response
          })
        }
      })
    })
  },
  getUploadedBanner(callback) {
    let s3bucket = new AWS.S3({
      region: BUCKET_REGION,
      accessKeyId: IAM_USER_KEY,
      secretAccessKey: IAM_USER_SECRET,
      Bucket: BUCKET_NAME
    })

    var paramss = {
      Bucket: BUCKET_NAME,
      Key: 'app/v1.json',
    }
    s3bucket.getObject(paramss, function (err, existingdata) {
      var json = JSON.parse(existingdata.Body.toString('utf-8'))
      callback(json)
    })
  },

  uploadAndGetBannerLink(file, banner, callback) {
    let s3bucket = new AWS.S3({
      region: BUCKET_REGION,
      accessKeyId: IAM_USER_KEY,
      secretAccessKey: IAM_USER_SECRET,
      Bucket: BUCKET_NAME
    })

    s3bucket.createBucket(function (data) {
      var params = {
        Bucket: BUCKET_NAME,
        Key: 'app/top_banner/' + file.name,
        Body: file.data
      }

      s3bucket.upload(params, function (err, data) {
        if (err) {
          callback(err)
        } else {
          var paramss = {
            Bucket: BUCKET_NAME,
            Key: 'app/v1.json',
          }
          s3bucket.getObject(paramss, function (err, existingdata) {
            var json = JSON.parse(existingdata.Body.toString('utf-8'))
            if (banner == 'US') {
              json.view_us.top_banner_image_url = data.Location
            } else {
              json.view.top_banner_image_url = data.Location
            }
            console.log("data-->>",data)
            console.log("err-->>",err)
            callback(data.Location)

            // var file = JSON.stringify(json)
            // paramss.Body = file
            // s3bucket.putObject(paramss, function (err, datass) {
            //   if (!err) {
            //     cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
            //       if (err) console.log(err, err.stack) // an error occurred
            //       else callback(data) // successful response
            //     })

            //   }
            // })
          })
        }
      })
    })
  },






}



// WEBPACK FOOTER //
// ./src/services/s3Upload.js